import * as React from 'react';
import clsx from 'clsx';
import { useNavigate } from 'react-router-dom';
import logoutIcon from '@/assets/images/svg/logout_icon.svg';
import type { SidebarFooterProps } from './types';

export const SidebarFooter: React.FC<SidebarFooterProps> = ({
  isCollapsed,
  onLogout,
  onSupport,
}) => {
  const navigate = useNavigate();
  return (
    <div
      className={clsx(
        'border-t border-gray-100',
        'pb-[clamp(10px,1.5dvh,24px)] xl:pb-6',
        isCollapsed
          ? 'flex flex-col items-center px-0 pt-3'
          : 'px-6 pt-[clamp(6px,1dvh,16px)] xl:pt-4'
      )}
    >
      {/* Logout */}
      <button
        onClick={onLogout}
        className={clsx(
          'group flex items-center gap-2',
          'transition-opacity hover:opacity-80',
          isCollapsed ? 'w-full justify-center' : 'w-full justify-start'
        )}
        title='Logout'
      >
        <img src={logoutIcon} alt='' className='size-[13px] shrink-0' />
        <span
          className={clsx(
            'font-sans font-medium tracking-normal text-red-400',
            isCollapsed ? 'text-12 leading-27' : 'text-14 leading-27'
          )}
        >
          Logout
        </span>
      </button>

      {/* Helper Links */}
      <div
        className={clsx(
          'flex flex-col',
          isCollapsed
            ? 'mt-2 w-full items-start gap-1 pl-4 text-left'
            : 'mt-[clamp(2px,0.5dvh,8px)] gap-0.5 xl:mt-2'
        )}
      >
        {/* Help & Support - Converted to button */}
        <button
          onClick={(e) => {
            e.preventDefault();
            onSupport();
          }}
          className={clsx(
            'text-left font-sans font-normal tracking-normal text-gray-500 transition-colors hover:text-gray-900',
            isCollapsed ? 'text-12 leading-14' : 'text-14 leading-[18px]'
          )}
        >
          {isCollapsed ? (
            <>
              <span className='block'>Help &</span>
              <span className='block'>Support</span>
            </>
          ) : (
            'Help & Support'
          )}
        </button>

        {/* Terms & Conditions */}
        <button
          onClick={(e) => {
            e.preventDefault();
            navigate('/info?tab=terms');
          }}
          className={clsx(
            'text-left font-sans font-normal tracking-normal text-gray-500 transition-colors hover:text-gray-900',
            !isCollapsed && 'underline decoration-solid decoration-auto underline-offset-auto',
            isCollapsed ? 'text-12 leading-14' : 'text-14 leading-20'
          )}
        >
          {isCollapsed ? (
            <>
              <span className='block'>Terms &</span>
              <span className='block'>Conditions</span>
            </>
          ) : (
            'Terms & Conditions'
          )}
        </button>

        {/* Cookie Policy */}
        <button
          onClick={(e) => {
            e.preventDefault();
            navigate('/info?tab=cookie');
          }}
          className={clsx(
            'text-left font-sans font-normal tracking-normal text-gray-500 transition-colors hover:text-gray-900',
            !isCollapsed && 'underline decoration-solid decoration-auto underline-offset-auto',
            isCollapsed ? 'text-12 leading-14' : 'text-14 leading-20'
          )}
        >
          {isCollapsed ? (
            <>
              <span className='block'>Cookie</span>
              <span className='block'>Policy</span>
            </>
          ) : (
            'Cookie Policy'
          )}
        </button>

        {/* Creator Agreements */}
        <button
          onClick={(e) => {
            e.preventDefault();
            navigate('/info?tab=creator');
          }}
          className={clsx(
            'text-left font-sans font-normal tracking-normal text-gray-500 transition-colors hover:text-gray-900',
            !isCollapsed && 'underline decoration-solid decoration-auto underline-offset-auto',
            isCollapsed ? 'text-12 leading-14' : 'text-14 leading-20'
          )}
        >
          {isCollapsed ? (
            <>
              <span className='block'>Creator</span>
              <span className='block'>Agreements</span>
            </>
          ) : (
            'Creator Agreements'
          )}
        </button>
      </div>
    </div>
  );
};

export default SidebarFooter;
